import Svg, { SvgEnum } from "../../../../ui library/components/svgs/standard/svg";
import useOtherLiensBalanceSection from "../../hooks/useOtherLiensBalanceSection";
import { SETTLEMENT_STYLES } from "../../style/styles";

import OtherLiensBalanceDeleteModal from "./modal/OtherLiensBalanceDeleteModal";
import OtherLiensBalanceModal from "./modal/OtherLiensBalanceModal";
import OtherLiensBalanceAddButton from "./OtherLiensBalanceAddButton";
import OtherLiensBalanceTable from "./OtherLiensBalanceTable";
import OtherLiensBalanceTotalCapsule from "./OtherLiensBalanceTotalCapsule";

export default function OtherLiensBalanceSection() {
  const {
    expenses,
    expenseTotal,
    caseDetail,
    deductionTypeOptions,
    deductionTypeDisplayMap,
    isLoading,
    canViewExpenses,
    canAddExpenses,
    canEditExpenses,
    canDeleteExpenses,
    modalState,
    fetchExpenses,
    handleOpenAddModal,
    handleOpenEditModal,
    handleOpenDeleteModal,
    handleCloseModal,
  } = useOtherLiensBalanceSection();

  if (!canViewExpenses) {
    return null;
  }

  return (
    <>
      <section
        className="flex min-h-[220px] max-h-[420px] flex-col overflow-hidden rounded-[12px] p-4 shadow-sm"
        style={SETTLEMENT_STYLES.sectionCard}
      >
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <Svg
              name={SvgEnum.HisLawFirm}
              color={SETTLEMENT_STYLES.sectionIconColor}
              sx={SETTLEMENT_STYLES.sectionIcon}
            />
            <h3 className="text-lg font-semibold" style={SETTLEMENT_STYLES.sectionTitle}>
              Other Liens and Balance
            </h3>
          </div>
          {canAddExpenses ? <OtherLiensBalanceAddButton onClick={handleOpenAddModal} /> : null}
        </div>

        <div className="mt-4 flex min-h-0 flex-1 flex-col overflow-y-auto">
          <OtherLiensBalanceTable
            data={expenses}
            isLoading={isLoading}
            deductionTypeDisplayMap={deductionTypeDisplayMap}
            onEdit={handleOpenEditModal}
            onDelete={handleOpenDeleteModal}
            canEdit={canEditExpenses}
            canDelete={canDeleteExpenses}
          />
        </div>

        {expenses.length ? (
          <div className="mt-4">
            <OtherLiensBalanceTotalCapsule value={expenseTotal} />
          </div>
        ) : null}
      </section>

      <OtherLiensBalanceModal
        openModal={modalState.mode === "add" || modalState.mode === "edit"}
        caseId={caseDetail?.pk}
        mode={modalState.mode}
        expenseData={modalState.expense}
        deductionTypeOptions={deductionTypeOptions}
        handleCloseModal={handleCloseModal}
        onSaveSuccess={fetchExpenses}
      />

      <OtherLiensBalanceDeleteModal
        openModal={modalState.mode === "delete"}
        expenseData={modalState.expense}
        deductionTypeDisplayMap={deductionTypeDisplayMap}
        handleCloseModal={handleCloseModal}
        onDeleteSuccess={fetchExpenses}
      />
    </>
  );
}
